<template>
  <v-container>
    <v-card>
      <v-img
        class="white--text align-end"
        height="500px" contain
        src="/image/public/promos/ParkFreeOneYear.png"></v-img>
      <v-layout row
                wrap>
        <v-flex xs12
                class="pa-2">

          <v-list class="n-lines">
            <v-subheader>Condiciones promoción Aparca Gratis 1 Año</v-subheader>
            <v-list-tile v-for="item in items"
                         class="pa-2"
                         :key="item.title">
              <v-list-tile-action>
                <v-icon color="primary">check</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-subtile v-html="item.title"
                                     style="font-size:14px"></v-list-tile-subtile>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ParkFreeOneYear',
  data() {
    return {
      items: [
          { title: '<b>Premio:</b> wesmartPark sorteará 1 año gratis a 4 usuarios valorados en 500 horas cada uno en parkings de Madrid y Barcelona, el equivalente a la reserva media habitual en las ciudades de Madrid y Barcelona: 3 horas x 3 días a la semana. Las 500 horas de parking regaladas tendrán una validez para su consumo por parte del usuario desde 02/06/2020 al 02/06/2021.' },
          { title: '<b>Participación:</b> Podrán participar todas las personas mayores de edad que hayan compartido en Twitter el Twitt patrocinado, siguiendo la cuenta @wesmartPark y citado al menos a un/a amigo/a durante los días 2 y 9 de Junio de 2020, ambos inclusive.' },
          { title: '<b>Número de participaciones:</b> Podrán participar un máximo de 7 veces diarias. Cada twitt que reúna las condiciones anteriores contabilizará como una participación.' },
          { title: '<b>Sorteo:</b> El sorteo se realizará mediante la plataforma sortea2 el día 10 de Junio a las 10:00 am, dándose a conocer los resultados ese mismo día a través de Twitter.' },
          { title: '<b>Ganadores/as:</b> Si bien las participaciones pueden ser múltiples, solo podrán ganar una sola vez, retirándose de la plataforma de sorteo su participación una vez que haya resultado ganador/a.' },
          { title: '<b>Reclamación del premio:</b> Para poder hacer eficiente el premio, una vez anunciado en Twitter deberán seguir @wesmartPark para que la empresa envíe las indicaciones para reclamar el premio: email y asunto. De esta forma evitamos reclamaciones fraudulentas.' }
        ]
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
